import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// VENDOR CREATION APIs
// Legacy route: /Purchase/VendorCreation
// Covers: Supplier/Trading vendor form, Service Provider vendor form,
// the vendor listing grid, and shared lookups (nature/master/sub group,
// states, TDS codes, SP categories).
// ==============================================

const get = async (path, params, errMsg) => {
    try {
        const queryParams = new URLSearchParams(params || {});
        const qs = queryParams.toString();
        const response = await axios.get(
            `${API_BASE_URL}${path}${qs ? `?${qs}` : ''}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(`❌ ${errMsg}:`, error.response || error);
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

const post = async (path, body, errMsg) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${path}`,
            body,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(`❌ ${errMsg}:`, error.response || error);
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// ── Shared lookups ────────────────────────────────────────────────────────────

export const getNatureofGroups = () =>
    get('/Accounts/GetNatureofGroups', {}, 'Get Nature of Groups API Error');

export const getMasterGroupsByNature = (natureGroupId) =>
    get('/Accounts/GetMasterGroupbsbyNature', { NatureGroupId: natureGroupId }, 'Get Master Groups API Error');

export const getSubGroupsByGroupId = (groupId) =>
    get('/Accounts/GetAllSubGroupsbyGroupid', { GroupId: groupId }, 'Get Sub Groups API Error');

export const getStatesList = () =>
    get('/Accounts/GetStatesList', {}, 'Get States List API Error');

export const getAllTdsCodes = () =>
    get('/Purchase/GetAllTdsCodes', {}, 'Get All TDS Codes API Error');

export const getAllSPCategories = () =>
    get('/Purchase/GetAllspcategory', {}, 'Get All SP Categories API Error');

export const getSPCategoryDetails = (val) =>
    get('/Purchase/GetSPCategoryDetails', { val }, 'Get SP Category Details API Error');

// ── Save ─────────────────────────────────────────────────────────────────────

export const saveNewVendor = (vendor) =>
    post('/Purchase/SaveNewVendor', vendor, 'Save New Vendor API Error');

export const saveNewVendorSP = (vendor) =>
    post('/Purchase/SaveNewVendorSP', vendor, 'Save New Vendor SP API Error');

// ── Grid / detail ────────────────────────────────────────────────────────────

export const getAllVendors = () =>
    get('/Purchase/GetAllVendors', {}, 'Get All Vendors API Error');

export const getVendorDetailsByCode = (vendorCode, roleId) =>
    get('/Purchase/GetVerificationVendorbyCode', { VendorCode: vendorCode, RoleId: roleId }, 'Get Vendor Details API Error');
